<ng-ut-load-train-confirmation-dialog
  [data]="data.record"
  [commodity]="data.loadTrain.commodity"
  [origin]="data.loadTrain.origin"
  [shipmentId]="data.record.shipmentId!"
  (loadShipment)="loadShipment($event)"
></ng-ut-load-train-confirmation-dialog>
